import ExpandableDatatableCard from "../../../components/ExpandableDatatableCard/ExpandableDatatableCard";
import useModal from "../../../hooks/useModal";
import { useStore } from "../../../store/useStore";

const JourneyOverviewTable = () => {
  const { pushModal } = useModal();
  const journeyOverview = useStore((state) => state.journeyControl.journeyOverview.data);
  const isLoadingjourneyOverviewt = useStore(
    (state) => state.infraction.isLoadingInfractionRankingList
  );

  return (
    <>
      {journeyOverview.map((item, rowIndex) => (
        <ExpandableDatatableCard 
          journeyOverviewItem={item}
        />
      ))}
    </>
  )
};

export default JourneyOverviewTable;
